import React from "react";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { variables } from "@sscs/ui/styles";
import { ReleaseStatusCount } from "../../../types";
import { transformTimelineData } from "../utils";
import styles from "./insights.module.scss";

type DateChartProps = {
  timeline: Record<string, ReleaseStatusCount>;
};

const DateChart = ({ timeline }: DateChartProps): React.JSX.Element => {
  const transformedData = Object.entries(transformTimelineData(timeline)).map(
    ([date, count]) => ({
      label: date,
      Pass: count.pass,
      Fail: count.fail,
    }),
  );

  return (
    <ResponsiveContainer width="100%" height={parseInt(styles.chartHeight)}>
      <LineChart
        data={transformedData}
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <Legend verticalAlign="top" itemSorter={null} />
        <XAxis dataKey="label" tickMargin={8} />
        <YAxis tickFormatter={(count: number) => count.toLocaleString()} />
        <Tooltip />
        <Line type="monotone" dataKey="Pass" stroke={variables.analysis_pass} />
        <Line type="monotone" dataKey="Fail" stroke={variables.analysis_fail} />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default DateChart;
